export const Circle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 8 9"
      fill={props.color || "none"}
    >
      <circle
        cx="4"
        cy="4.5"
        r="3.5"
        stroke={props.stroke || "#404040"}
        strokeOpacity={props.strokeOpacity || "0.5"}
      />
    </svg>
  );
};

export const CircleWrongIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4344_31301)">
        <path
          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
          stroke={props.color || "#D0405A"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6665 6.66699L9.33317 9.33366M9.33317 6.66699L6.6665 9.33366"
          stroke={props.color || "#D0405A"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4344_31301">
          <rect
            width={props.width || "16"}
            height={props.height || "16"}
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TimeIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.5C4.6875 2.5 2 5.1875 2 8.5C2 11.8125 4.6875 14.5 8 14.5C11.3125 14.5 14 11.8125 14 8.5C14 5.1875 11.3125 2.5 8 2.5Z"
        stroke={props.color || "#404040"}
        strokeMiterlimit="10"
      />
      {props.showTime === false ? (
        <path
          d="M10 8.5H6"
          stroke={props.color || "#404040"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M7 5.5V9.25L10 10.5"
          stroke={props.color || "#404040"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export const CircleTickIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4344_31328)">
        <path
          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
          stroke={props.color || "#CFCFCF"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.00033L7.33333 9.33366L10 6.66699"
          stroke={props.color || "#CFCFCF"}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4344_31328">
          <rect
            width={props.width || "16"}
            height={props.height || "16"}
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EyeOpenIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 4.33333C5.58182 4.33333 3.41818 5.73333 2.4 8H1C2.08182 5.06667 4.81818 3 8 3C11.1818 3 13.9182 5.06667 15 8H13.6C12.5818 5.73333 10.4182 4.33333 8 4.33333Z"
        fill={props.color || "#4E4E4E"}
      />
      <circle cx="8" cy="10" r="2" fill={props.color || "#4E4E4E"} />
    </svg>
  );
};

export const EyeCloseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 11.6667C5.58182 11.6667 3.41818 10.2667 2.4 8H1C2.08182 10.9333 4.81818 13 8 13C11.1818 13 13.9182 10.9333 15 8H13.6C12.5818 10.2667 10.4182 11.6667 8 11.6667Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const NoImageProvidedIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0.707L13.293 0L0 13.293L0.707 14L1.707 13H12C12.2651 12.9996 12.5192 12.8941 12.7067 12.7067C12.8941 12.5192 12.9996 12.2651 13 12V1.707L14 0.707ZM12 12H2.707L6.6035 8.1035L7.793 9.293C7.98053 9.48047 8.23484 9.58579 8.5 9.58579C8.76516 9.58579 9.01947 9.48047 9.207 9.293L10 8.5L12 10.4985V12ZM12 9.084L10.707 7.791C10.5195 7.60353 10.2652 7.49821 10 7.49821C9.73484 7.49821 9.48053 7.60353 9.293 7.791L8.5 8.584L7.3115 7.3955L12 2.707V9.084ZM2 10V8.5L4.5 6.0015L5.1865 6.6885L5.8945 5.9805L5.207 5.293C5.01947 5.10553 4.76516 5.00021 4.5 5.00021C4.23484 5.00021 3.98053 5.10553 3.793 5.293L2 7.086V2H10V1H2C1.73486 1.00026 1.48066 1.10571 1.29319 1.29319C1.10571 1.48066 1.00026 1.73486 1 2V10H2Z"
        fill="white"
      />
    </svg>
  );
};

export const ErrorIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47396 6.82353C7.47396 6.5528 7.70948 6.33333 8 6.33333C8.29052 6.33333 8.52604 6.5528 8.52604 6.82353V8.78431C8.52604 9.05504 8.29052 9.27451 8 9.27451C7.70948 9.27451 7.47396 9.05504 7.47396 8.78431V6.82353Z"
        fill="#FF0000"
      />
      <path
        d="M8 9.86274C7.70948 9.86274 7.47396 10.0822 7.47396 10.3529C7.47396 10.6237 7.70948 10.8431 8 10.8431C8.29052 10.8431 8.52604 10.6237 8.52604 10.3529C8.52604 10.0822 8.29052 9.86274 8 9.86274Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7653 10.5962L13.7682 10.6009C14.4348 11.6837 13.58 13 12.2719 13H3.72807C2.41997 13 1.56522 11.6838 2.23184 10.6009L2.23474 10.5962L6.51054 3.7972C6.66259 3.55357 6.88045 3.35267 7.14088 3.21336C7.40278 3.07327 7.69912 3 8 3C8.30088 3 8.59723 3.07327 8.85912 3.21336C9.11958 3.35268 9.33745 3.55361 9.48949 3.79725L13.7653 10.5962ZM8.39884 4.38982L12.6731 11.1864C12.8483 11.471 12.627 11.8235 12.2719 11.8235H3.72807C3.37303 11.8235 3.15171 11.471 3.32692 11.1864L7.60116 4.38982C7.64132 4.32501 7.69936 4.27114 7.7694 4.23367C7.83945 4.19621 7.919 4.17647 8 4.17647C8.081 4.17647 8.16055 4.19621 8.2306 4.23367C8.30064 4.27114 8.35868 4.32501 8.39884 4.38982Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const UpdateReloadIcon = (props) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9613 2.86918C16.4015 3.12884 16.9876 3.07144 17.3104 2.68402C17.6333 2.29629 17.5697 1.72627 17.1357 1.45655C16.7212 1.199 16.2839 0.97168 15.8273 0.777627C13.835 -0.069003 11.5968 -0.229934 9.49417 0.322414C7.39152 0.874686 5.55451 2.10607 4.2961 3.8066C3.29843 5.15483 2.71342 6.73188 2.59212 8.36239C2.56993 8.66059 2.31451 8.90146 1.99835 8.90146H0.577836C0.117027 8.90146 -0.157773 9.38712 0.0979392 9.7496L2.96057 13.8074C3.18892 14.1311 3.69201 14.1311 3.92036 13.8074L6.78299 9.7496C7.03871 9.38712 6.76391 8.90146 6.3031 8.90146H5.03235C4.71071 8.90146 4.44898 8.65235 4.47774 8.34943C4.59696 7.09371 5.06005 5.88248 5.8303 4.84159C6.8379 3.47989 8.30886 2.494 9.99244 2.05174C11.6761 1.60948 13.4682 1.73829 15.0635 2.41626C15.3745 2.54845 15.6743 2.69992 15.9613 2.86918Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M8.03873 15.1308C7.59852 14.8712 7.01237 14.9286 6.68964 15.316C6.36666 15.7037 6.43025 16.2737 6.86434 16.5434C7.27885 16.801 7.71607 17.0283 8.17268 17.2224C10.165 18.069 12.4032 18.2299 14.5058 17.6776C16.6085 17.1253 18.4455 15.8939 19.7039 14.1934C20.7016 12.8452 21.2866 11.2681 21.4079 9.63761C21.4301 9.33941 21.6855 9.09854 22.0016 9.09854H23.4222C23.883 9.09854 24.1578 8.61288 23.9021 8.2504L21.0394 4.19258C20.8111 3.86889 20.308 3.86889 20.0796 4.19258L17.217 8.2504C16.9613 8.61287 17.2361 9.09854 17.6969 9.09854H18.9676C19.2893 9.09854 19.551 9.34765 19.5223 9.65057C19.403 10.9063 18.94 12.1175 18.1697 13.1584C17.1621 14.5201 15.6911 15.506 14.0076 15.9483C12.3239 16.3905 10.5318 16.2617 8.93654 15.5837C8.62549 15.4515 8.32567 15.3001 8.03873 15.1308Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
};

export const RotateIcon = (props) => {
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "16"}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.8337C11.2234 0.646152 9.4897 -0.00254483 7.70033 0.000498944C6.00088 0.000374291 4.34933 0.583725 3.00266 1.66087C1.65613 2.73805 0.690298 4.24766 0.255917 5.95463C-0.178584 7.66172 -0.0573301 9.4702 0.600781 11.098C1.25901 12.726 2.4169 14.0819 3.89434 14.9545C5.37147 15.8272 7.08524 16.1675 8.76823 15.9226C10.4511 15.6776 12.0088 14.8609 13.1984 13.6C13.3328 13.4633 13.4087 13.276 13.4087 13.0806C13.4088 12.8851 13.3331 12.6978 13.1988 12.561C13.0645 12.4241 12.8828 12.3493 12.6947 12.3531C12.5066 12.357 12.328 12.4395 12.199 12.5818C11.6143 13.2058 10.9146 13.7011 10.1417 14.0384C9.36891 14.3758 8.53867 14.5482 7.70047 14.5454C6.35161 14.5454 5.03833 14.0956 3.95393 13.2623C2.86951 12.4291 2.07117 11.2559 1.67638 9.91603C1.28158 8.57619 1.31113 7.13989 1.76075 5.81864C2.21025 4.4975 3.05618 3.36095 4.17387 2.5765C5.29153 1.79206 6.622 1.40112 7.96961 1.46102C9.31715 1.52105 10.6106 2.02875 11.6597 2.90963H10.5001C10.25 2.90963 10.019 3.04817 9.89393 3.27318C9.7689 3.49818 9.7689 3.77553 9.89393 4.00052C10.019 4.22552 10.25 4.36407 10.5001 4.36407H13.3001C13.4857 4.36407 13.6637 4.28749 13.7949 4.15113C13.9263 4.01477 14 3.8297 14 3.63685V0.727844C14 0.468024 13.8665 0.227935 13.65 0.0980248C13.4334 -0.031885 13.1666 -0.031885 12.95 0.0980248C12.7335 0.227935 12.6 0.468028 12.6 0.727844V1.8337Z"
        fill={props.color || "white"}
      />
      {!props.removeDot && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.72042 9.02898L6.71038 10.0575C6.97311 10.3299 7.3291 10.4828 7.70022 10.4828C8.07133 10.4828 8.42733 10.3299 8.69005 10.0575L9.68001 9.02898C9.94216 8.75601 10.0893 8.38613 10.0893 8.00055C10.0893 7.61496 9.94215 7.24508 9.68001 6.97212L8.69005 5.94356C8.42733 5.67122 8.07133 5.51818 7.70022 5.51818C7.3291 5.51818 6.9731 5.6712 6.71038 5.94356L5.72042 6.97212C5.4583 7.24509 5.311 7.61496 5.311 8.00055C5.311 8.38613 5.45829 8.75601 5.72042 9.02898Z"
          fill={props.color || "white"}
        />
      )}
    </svg>
  );
};

export const SuccessIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "12"}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33339 11.3684C5.66067 11.7173 6.1913 11.7173 6.51858 11.3684L15.4074 1.89476C15.7347 1.54595 15.7347 0.980413 15.4074 0.631602C15.0802 0.282792 14.5495 0.282793 14.2223 0.631604L6.5186 8.8421C6.19132 9.19091 5.6607 9.19091 5.33342 8.8421L1.77781 5.05257C1.45053 4.70375 0.919908 4.70376 0.592628 5.05257C0.26535 5.40138 0.265347 5.96691 0.592624 6.31572L5.33339 11.3684Z"
        fill="#00a000"
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.width || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33337 12.6666L12.6667 3.33325"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M12.6667 12.6667L3.33337 3.33342"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CheckBoxInActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.69999"
        y="1.70005"
        width="12.6"
        height="12.6"
        rx="1.1"
        stroke={props.color || "white"}
        strokeWidth="1.8"
      />
    </svg>
  );
};

export const CheckBoxActiveIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7998 0.800049C1.69524 0.800049 0.799805 1.69548 0.799805 2.80005V13.2C0.799805 14.3046 1.69524 15.2 2.79981 15.2H13.1998C14.3044 15.2 15.1998 14.3046 15.1998 13.2V2.80005C15.1998 1.69548 14.3044 0.800049 13.1998 0.800049H2.7998ZM12.1669 5.03368C12.4793 5.3461 12.4793 5.85263 12.1669 6.16505L7.36549 10.9665C7.18302 11.149 6.93434 11.2248 6.69678 11.1942C6.52755 11.1724 6.36395 11.0965 6.23396 10.9665L3.83324 8.56575C3.52082 8.25333 3.52082 7.7468 3.83324 7.43438C4.14566 7.12196 4.65219 7.12196 4.96461 7.43438L6.79973 9.2695L11.0356 5.03368C11.348 4.72126 11.8545 4.72126 12.1669 5.03368Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const ValidIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22275 11.5C6.96616 11.7478 6.55014 11.7478 6.29355 11.5L3.19238 8.5C2.93579 8.25218 2.93579 7.85038 3.19239 7.60256C3.44898 7.35473 3.865 7.35473 4.12159 7.60256L6.29357 9.7051C6.55016 9.95292 6.96618 9.95292 7.22277 9.7051L11.455 5.18587C11.7116 4.93805 12.1277 4.93804 12.3843 5.18587C12.6408 5.43369 12.6408 5.83549 12.3843 6.08331L7.22275 11.5Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.8 8C14.8 11.7555 11.7555 14.8 8 14.8C4.24446 14.8 1.2 11.7555 1.2 8C1.2 4.24446 4.24446 1.2 8 1.2C11.7555 1.2 14.8 4.24446 14.8 8Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3 10.1H8.7V11.5H7.3V10.1ZM7.3 4.5H8.7V8.7H7.3V4.5ZM8 1C4.129 1 1 4.15 1 8C1 9.85651 1.7375 11.637 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.17049 14.8189 7.08075 15 8 15C9.85651 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85651 15 8C15 7.08075 14.8189 6.17049 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.8295 1.18106 8.91925 1 8 1ZM8 13.6C6.51479 13.6 5.09041 13.01 4.0402 11.9598C2.99 10.9096 2.4 9.48521 2.4 8C2.4 6.51479 2.99 5.09041 4.0402 4.0402C5.09041 2.99 6.51479 2.4 8 2.4C9.48521 2.4 10.9096 2.99 11.9598 4.0402C13.01 5.09041 13.6 6.51479 13.6 8C13.6 9.48521 13.01 10.9096 11.9598 11.9598C10.9096 13.01 9.48521 13.6 8 13.6Z"
        fill={props.color}
      />
    </svg>
  );
};

export const CameraFlipIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1819 6.23294H14.5099L12.3893 4.11094C11.7065 3.42818 10.8561 2.9372 9.9234 2.68734C8.99074 2.43748 8.00873 2.43755 7.0761 2.68755C6.14348 2.93755 5.2931 3.42866 4.61046 4.11152C3.92781 4.79437 3.43697 5.6449 3.18726 6.5776M2.48992 13.0969V9.76894M2.48992 9.76894H5.81792M2.48992 9.76894L4.60992 11.8909C5.29267 12.5737 6.14312 13.0647 7.07578 13.3145C8.00845 13.5644 8.99045 13.5643 9.92308 13.3143C10.8557 13.0643 11.7061 12.5732 12.3887 11.8904C13.0714 11.2075 13.5622 10.357 13.8119 9.42427M14.5099 2.90494V6.2316"
        stroke="#1C1C1C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.6"
        cx="16"
        cy="16"
        r="15.5"
        fill={props.color || "#C2C2C2"}
        stroke="#C2C2C2"
      />
      <path
        d="M10 22.5365V19.6982C10 17.4208 11.9188 15.5745 14.2857 15.5745H18.5714C20.9384 15.5745 22.8571 17.4208 22.8571 19.6982V22.5365C21.1326 24.0716 18.8858 25 16.4286 25C13.9714 25 11.7245 24.0716 10 22.5365Z"
        fill={props.color || "#C2C2C2"}
      />
      <path
        d="M20.3968 10.9273C20.3968 13.042 18.6264 14.9855 16.4286 14.9855C14.2307 14.9855 12.4603 13.042 12.4603 10.9273C12.4603 8.81252 14.2307 7 16.4286 7C18.6264 7 20.3968 8.81252 20.3968 10.9273Z"
        fill={props.color || "#C2C2C2"}
      />
    </svg>
  );
};

export const ProfileEditIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6507 6.54222L1.25978 8.23245C1.2463 8.29424 1.24676 8.35827 1.26114 8.41985C1.27551 8.48144 1.30344 8.53903 1.34287 8.58841C1.38231 8.6378 1.43226 8.67774 1.48908 8.70531C1.5459 8.73288 1.60814 8.74739 1.67127 8.74777C1.70069 8.75074 1.73033 8.75074 1.75974 8.74777L3.45713 8.35613L7.59935 4.21874L5.78191 2.40204L5.78057 2.40071L1.6507 6.54222ZM5.78148 3.43062L2.31299 6.90868L2.07732 7.92769L3.0904 7.69394L6.56954 4.21835L5.78148 3.43062ZM8.62602 3.1943C8.66551 3.15453 8.69679 3.10736 8.71806 3.05547C8.73934 3.00358 8.75019 2.94799 8.75 2.8919C8.74981 2.8358 8.73858 2.78029 8.71695 2.72855C8.69532 2.67681 8.66372 2.62985 8.62396 2.59035L7.41007 1.37421C7.33026 1.29466 7.22226 1.25 7.10969 1.25C6.99711 1.25 6.8891 1.29466 6.8093 1.37421L6.1345 2.05025L7.95118 3.87039L8.62602 3.1943Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const DefaultUserProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "56"}
      height={props.height || "56"}
      viewBox="0 0 56 56"
      fill="none"
    >
      <circle cx="28" cy="28" r="28" fill="#F2F2F2" />
      <path
        d="M14 41.6625V35.5127C14 30.5783 18.1787 26.5782 23.3333 26.5782H32.6667C37.8213 26.5782 42 30.5783 42 35.5127V41.6625C38.2444 44.9885 33.3512 47 28 47C22.6488 47 17.7556 44.9885 14 41.6625Z"
        fill="white"
      />
      <path
        d="M36.642 16.5091C36.642 21.091 32.7865 25.3018 28 25.3018C23.2135 25.3018 19.358 21.091 19.358 16.5091C19.358 11.9271 23.2135 8 28 8C32.7865 8 36.642 11.9271 36.642 16.5091Z"
        fill="white"
      />
    </svg>
  );
};

export const DefaultCorporateProfileIcon = (props) => {
  return (
    <svg
      width={props.width || "48"}
      height={props.height || "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#F1F1F1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3684 10C20.4383 10 19.6842 10.7429 19.6842 11.6593V17.0519H15.6842C14.754 17.0519 14 17.7947 14 18.7111V38H19.6842V17.0519H23.4737C24.4038 17.0519 25.1579 17.7947 25.1579 18.7111V38H34V11.6593C34 10.7429 33.246 10 32.3158 10H21.3684Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};

export const ExitIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33325V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6666 8L11.3333 4.66667ZM2.66659 3.33333H7.99992V2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V12.6667C1.33325 13.4 1.93325 14 2.66659 14H7.99992V12.6667H2.66659V3.33333Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.20668 4.47319C6.14488 4.53486 6.09585 4.60812 6.06239 4.68877C6.02894 4.76942 6.01172 4.85587 6.01172 4.94319C6.01172 5.0305 6.02894 5.11695 6.06239 5.1976C6.09585 5.27825 6.14488 5.35151 6.20668 5.41319L8.79335 7.99985L6.20668 10.5865C6.08203 10.7112 6.012 10.8802 6.012 11.0565C6.012 11.2328 6.08203 11.4019 6.20668 11.5265C6.33133 11.6512 6.5004 11.7212 6.67668 11.7212C6.85297 11.7212 7.02203 11.6512 7.14668 11.5265L10.2067 8.46652C10.2685 8.40484 10.3175 8.33158 10.351 8.25093C10.3844 8.17029 10.4016 8.08383 10.4016 7.99652C10.4016 7.90921 10.3844 7.82275 10.351 7.7421C10.3175 7.66145 10.2685 7.58819 10.2067 7.52652L7.14668 4.46652C6.89335 4.21319 6.46668 4.21319 6.20668 4.47319Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const BackArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.54368 7.49951H13.9777C14.1161 7.49951 14.2488 7.55218 14.3466 7.64594C14.4445 7.7397 14.4994 7.86686 14.4994 7.99945C14.4994 8.13204 14.4445 8.2592 14.3466 8.35296C14.2488 8.44671 14.1161 8.49939 13.9777 8.49939H3.54368C3.40531 8.49939 3.27261 8.44671 3.17478 8.35296C3.07694 8.2592 3.02197 8.13204 3.02197 7.99945C3.02197 7.86686 3.07694 7.7397 3.17478 7.64594C3.27261 7.55218 3.40531 7.49951 3.54368 7.49951Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M3.75959 7.99951L8.0866 12.145C8.18456 12.2389 8.23959 12.3662 8.23959 12.4989C8.23959 12.6317 8.18456 12.759 8.0866 12.8529C7.98863 12.9468 7.85577 12.9995 7.71723 12.9995C7.57869 12.9995 7.44583 12.9468 7.34786 12.8529L2.65254 8.35347C2.60395 8.30703 2.56541 8.25186 2.53911 8.19112C2.51281 8.13038 2.49927 8.06527 2.49927 7.99951C2.49927 7.93375 2.51281 7.86864 2.53911 7.8079C2.56541 7.74717 2.60395 7.692 2.65254 7.64556L7.34786 3.14612C7.44583 3.05225 7.57869 2.99951 7.71723 2.99951C7.85577 2.99951 7.98863 3.05225 8.0866 3.14612C8.18456 3.24 8.23959 3.36732 8.23959 3.50008C8.23959 3.63284 8.18456 3.76016 8.0866 3.85404L3.75959 7.99951Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ClockIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 15.5C6.61553 15.5 5.26216 15.0895 4.11101 14.3203C2.95987 13.5511 2.06266 12.4579 1.53285 11.1788C1.00303 9.8997 0.86441 8.49224 1.13451 7.13437C1.4046 5.7765 2.07129 4.52922 3.05026 3.55026C4.02922 2.57129 5.2765 1.9046 6.63437 1.63451C7.99224 1.36441 9.3997 1.50303 10.6788 2.03285C11.9579 2.56266 13.0511 3.45987 13.8203 4.61101C14.5895 5.76216 15 7.11553 15 8.5C15 10.3565 14.2625 12.137 12.9497 13.4497C11.637 14.7625 9.85652 15.5 8 15.5ZM8 2.5C6.81332 2.5 5.65328 2.8519 4.66658 3.51119C3.67989 4.17047 2.91085 5.10755 2.45673 6.2039C2.0026 7.30026 1.88378 8.50666 2.11529 9.67054C2.3468 10.8344 2.91825 11.9035 3.75736 12.7426C4.59648 13.5818 5.66558 14.1532 6.82946 14.3847C7.99335 14.6162 9.19975 14.4974 10.2961 14.0433C11.3925 13.5892 12.3295 12.8201 12.9888 11.8334C13.6481 10.8467 14 9.68669 14 8.5C14 6.9087 13.3679 5.38258 12.2426 4.25736C11.1174 3.13214 9.5913 2.5 8 2.5Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M10.295 11.5L7.5 8.705V4H8.5V8.29L11 10.795L10.295 11.5Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.6749V3.32495"
        stroke={props.color || "#0E0E0E"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M12.6748 8L3.32483 8"
        stroke={props.color || "#0E0E0E"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.92413 13C4.77061 12.9997 4.61981 12.956 4.48657 12.8731C4.18653 12.6883 4 12.3296 4 11.9402V4.05983C4 3.66934 4.18653 3.31173 4.48657 3.12695C4.62299 3.04174 4.77796 2.99792 4.93529 3.00008C5.09263 3.00223 5.24654 3.05027 5.38094 3.13918L11.5781 7.17068C11.7072 7.25869 11.8137 7.38091 11.8875 7.52588C11.9613 7.67084 12 7.8338 12 7.99948C12 8.16516 11.9613 8.32812 11.8875 8.47308C11.8137 8.61805 11.7072 8.74027 11.5781 8.82828L5.37994 12.8609C5.2424 12.9512 5.08485 12.9993 4.92413 13Z"
        fill={props.color || "white"}
      />
    </svg>
  );
};

export const PauseIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 3H5V13H3V3Z" fill={props.color || "white"} />
      <path d="M10 3H12V13H10V3Z" fill={props.color || "white"} />
    </svg>
  );
};

export const MicIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 7.46154C9.99999 8.05444 9.78094 8.61628 9.40136 9.02506C9.02294 9.43259 8.51797 9.65385 7.99999 9.65385C7.48202 9.65385 6.97705 9.43259 6.59863 9.02506C6.21905 8.61628 6 8.05444 6 7.46154V3.69231C6 3.09941 6.21905 2.53756 6.59863 2.12878C6.97705 1.72125 7.48202 1.5 7.99999 1.5C8.51797 1.5 9.02294 1.72125 9.40136 2.12878C9.78094 2.53756 9.99999 3.09941 9.99999 3.69231V7.46154Z"
        fill={props.color || "white"}
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8C13.0013 8.6368 12.8858 9.26762 12.6601 9.85622C12.4345 10.4448 12.103 10.9796 11.6849 11.4299C11.2668 11.8802 10.7702 12.2371 10.2236 12.4802C9.67707 12.7232 9.09132 12.8476 8.5 12.8462H7.5C6.90868 12.8476 6.32293 12.7232 5.77637 12.4802C5.22981 12.2371 4.73321 11.8802 4.31509 11.4299C3.89696 10.9796 3.56555 10.4448 3.33987 9.85622C3.11419 9.26762 2.99869 8.6368 3.00001 8M8 12.8462V15"
        stroke={props.color || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StopIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <rect x="10" y="10" width="12" height="12" rx="2" fill="#0249D6" />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6875 14H1.3125C0.58625 14 0 13.4137 0 12.6875V2.1875C0 1.46125 0.58625 0.875 1.3125 0.875H12.6875C13.4137 0.875 14 1.46125 14 2.1875V12.6875C14 13.4137 13.4137 14 12.6875 14ZM1.3125 1.75C1.0675 1.75 0.875 1.9425 0.875 2.1875V12.6875C0.875 12.9325 1.0675 13.125 1.3125 13.125H12.6875C12.9325 13.125 13.125 12.9325 13.125 12.6875V2.1875C13.125 1.9425 12.9325 1.75 12.6875 1.75H1.3125Z"
        fill={props.color || "#404040"}
      />
      <path
        d="M3.9375 3.5C3.6925 3.5 3.5 3.3075 3.5 3.0625V0.4375C3.5 0.1925 3.6925 0 3.9375 0C4.1825 0 4.375 0.1925 4.375 0.4375V3.0625C4.375 3.3075 4.1825 3.5 3.9375 3.5ZM10.0625 3.5C9.8175 3.5 9.625 3.3075 9.625 3.0625V0.4375C9.625 0.1925 9.8175 0 10.0625 0C10.3075 0 10.5 0.1925 10.5 0.4375V3.0625C10.5 3.3075 10.3075 3.5 10.0625 3.5ZM13.5625 5.25H0.4375C0.1925 5.25 0 5.0575 0 4.8125C0 4.5675 0.1925 4.375 0.4375 4.375H13.5625C13.8075 4.375 14 4.5675 14 4.8125C14 5.0575 13.8075 5.25 13.5625 5.25Z"
        fill={props.color || "#404040"}
      />
    </svg>
  );
};

export const ProcedureTitleIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.354 5.104C7.44789 5.01011 7.50063 4.88278 7.50063 4.75C7.50063 4.61722 7.44789 4.48989 7.354 4.396C7.26011 4.30211 7.13278 4.24937 7 4.24937C6.86722 4.24937 6.73989 4.30211 6.646 4.396L5.234 5.808L4.837 5.446C4.73836 5.36169 4.6108 5.31903 4.48129 5.32703C4.35177 5.33504 4.23044 5.39308 4.14293 5.4889C4.05543 5.58472 4.0086 5.7108 4.01234 5.84051C4.01609 5.97022 4.07011 6.09339 4.163 6.184L4.913 6.869C5.00803 6.95552 5.13272 7.00213 5.2612 6.99915C5.38968 6.99617 5.51208 6.94383 5.603 6.853L7.353 5.103L7.354 5.104ZM7.354 9.396C7.40056 9.44245 7.43751 9.49762 7.46271 9.55837C7.48792 9.61911 7.50089 9.68423 7.50089 9.75C7.50089 9.81577 7.48792 9.88089 7.46271 9.94163C7.43751 10.0024 7.40056 10.0576 7.354 10.104L5.604 11.854C5.51291 11.945 5.39023 11.9973 5.26151 12.0001C5.13279 12.0029 5.00796 11.9559 4.913 11.869L4.163 11.184C4.07011 11.0934 4.01609 10.9702 4.01234 10.8405C4.0086 10.7108 4.05543 10.5847 4.14293 10.4889C4.23044 10.3931 4.35177 10.335 4.48129 10.327C4.6108 10.319 4.73836 10.3617 4.837 10.446L5.234 10.809L6.646 9.396C6.69245 9.34944 6.74762 9.31249 6.80837 9.28729C6.86911 9.26208 6.93423 9.24911 7 9.24911C7.06577 9.24911 7.13089 9.26208 7.19163 9.28729C7.25238 9.31249 7.30755 9.34944 7.354 9.396ZM9 10C8.86739 10 8.74021 10.0527 8.64645 10.1464C8.55268 10.2402 8.5 10.3674 8.5 10.5C8.5 10.6326 8.55268 10.7598 8.64645 10.8536C8.74021 10.9473 8.86739 11 9 11H11.5C11.6326 11 11.7598 10.9473 11.8536 10.8536C11.9473 10.7598 12 10.6326 12 10.5C12 10.3674 11.9473 10.2402 11.8536 10.1464C11.7598 10.0527 11.6326 10 11.5 10H9ZM8.5 5.5C8.5 5.36739 8.55268 5.24021 8.64645 5.14645C8.74021 5.05268 8.86739 5 9 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5C12 5.63261 11.9473 5.75979 11.8536 5.85355C11.7598 5.94732 11.6326 6 11.5 6H9C8.86739 6 8.74021 5.94732 8.64645 5.85355C8.55268 5.75979 8.5 5.63261 8.5 5.5ZM4 1C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H12C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1H4ZM2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4Z"
        fill="#404040"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 14.1253L8.48066 13.5835C9.02618 12.9588 9.51685 12.366 9.95342 11.8022L10.3138 11.3268C11.8186 9.29934 12.5713 7.6902 12.5713 6.50087C12.5713 3.9622 10.5248 1.9043 7.9999 1.9043C5.47494 1.9043 3.42847 3.9622 3.42847 6.50087C3.42847 7.6902 4.18123 9.29934 5.68599 11.3268L6.04637 11.8022C6.66918 12.6002 7.32079 13.3746 7.9999 14.1253Z"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 8.38081C9.05195 8.38081 9.90474 7.52802 9.90474 6.47605C9.90474 5.42408 9.05195 4.57129 7.99998 4.57129C6.94801 4.57129 6.09521 5.42408 6.09521 6.47605C6.09521 7.52802 6.94801 8.38081 7.99998 8.38081Z"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M6.875 22.375L15.625 31.125L33.125 12.375"
        stroke={props.color || "#404040"}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotInLocationPicture = (props) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 27.5C22.5 29.4891 23.2902 31.3968 24.6967 32.8033C26.1032 34.2098 28.0109 35 30 35C31.9891 35 33.8968 34.2098 35.3033 32.8033C36.7098 31.3968 37.5 29.4891 37.5 27.5C37.5 25.5109 36.7098 23.6032 35.3033 22.1967C33.8968 20.7902 31.9891 20 30 20C28.0109 20 26.1032 20.7902 24.6967 22.1967C23.2902 23.6032 22.5 25.5109 22.5 27.5Z"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5122 48.2759L33.5347 52.2509C32.5972 53.1875 31.3262 53.7136 30.001 53.7136C28.6758 53.7136 27.4048 53.1875 26.4672 52.2509L15.8572 41.6434C13.4553 39.2413 11.7047 36.2669 10.7708 33.0007C9.83678 29.7346 9.75013 26.2844 10.519 22.9755C11.2878 19.6666 12.8868 16.608 15.1651 14.0883C17.4434 11.5686 20.3261 9.67067 23.5411 8.57361C26.7561 7.47655 30.1976 7.21647 33.541 7.81791C36.8843 8.41935 40.0194 9.86249 42.6506 12.0112C45.2817 14.1599 47.3222 16.9434 48.5795 20.0992C49.8369 23.255 50.2697 26.6791 49.8372 30.0484"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 40V47.5"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 55V55.025"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoCaptureFallbackIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 22.5C25 23.8261 25.5268 25.0979 26.4645 26.0355C27.4021 26.9732 28.6739 27.5 30 27.5C31.3261 27.5 32.5979 26.9732 33.5355 26.0355C34.4732 25.0979 35 23.8261 35 22.5C35 21.1739 34.4732 19.9021 33.5355 18.9645C32.5979 18.0268 31.3261 17.5 30 17.5C28.6739 17.5 27.4021 18.0268 26.4645 18.9645C25.5268 19.9021 25 21.1739 25 22.5Z"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20V15C10 13.6739 10.5268 12.4021 11.4645 11.4645C12.4021 10.5268 13.6739 10 15 10H20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 40V45C10 46.3261 10.5268 47.5979 11.4645 48.5355C12.4021 49.4732 13.6739 50 15 50H20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 10H45C46.3261 10 47.5979 10.5268 48.5355 11.4645C49.4732 12.4021 50 13.6739 50 15V20"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 40C20 38.6739 20.5268 37.4021 21.4645 36.4645C22.4021 35.5268 23.6739 35 25 35H35C36.3261 35 37.5979 35.5268 38.5355 36.4645"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.75 52.75L44.75 44.75"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.75 52.75L52.75 44.75"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ZeroStateFallbackIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3996 9.22461C18.6698 10.3546 16.1893 12.0111 14.0996 14.0996"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.225 21.4004C8.09139 24.1261 7.50526 27.0483 7.5 30.0004"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.22461 38.5996C10.3546 41.3294 12.0111 43.8099 14.0996 45.8996"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4004 50.7754C24.1261 51.909 27.0483 52.4951 30.0004 52.5004"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5996 50.7754C41.3294 49.6454 43.8099 47.9889 45.8996 45.9004"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.7754 38.6C51.909 35.8743 52.4951 32.9521 52.5004 30"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.7754 21.3996C49.6454 18.6698 47.9889 16.1893 45.9004 14.0996"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6 9.225C35.8743 8.09139 32.9521 7.50526 30 7.5"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 30L27.5 35L37.5 25"
        stroke="#CFCFCF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoResultsFallbackIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 25C7.5 27.2981 7.95265 29.5738 8.83211 31.697C9.71157 33.8202 11.0006 35.7493 12.6256 37.3744C14.2507 38.9994 16.1798 40.2884 18.303 41.1679C20.4262 42.0474 22.7019 42.5 25 42.5C27.2981 42.5 29.5738 42.0474 31.697 41.1679C33.8202 40.2884 35.7493 38.9994 37.3744 37.3744C38.9994 35.7493 40.2884 33.8202 41.1679 31.697C42.0474 29.5738 42.5 27.2981 42.5 25C42.5 22.7019 42.0474 20.4262 41.1679 18.303C40.2884 16.1798 38.9994 14.2507 37.3744 12.6256C35.7493 11.0006 33.8202 9.71157 31.697 8.83211C29.5738 7.95265 27.2981 7.5 25 7.5C22.7019 7.5 20.4262 7.95265 18.303 8.83211C16.1798 9.71157 14.2507 11.0006 12.6256 12.6256C11.0006 14.2507 9.71157 16.1798 8.83211 18.303C7.95265 20.4262 7.5 22.7019 7.5 25Z"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.5 52.5L37.5 37.5"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 32.5V32.525"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0004 25C25.6296 25.0003 26.2489 24.8423 26.801 24.5405C27.3532 24.2386 27.8205 23.8027 28.1599 23.2728C28.4993 22.743 28.7 22.1362 28.7434 21.5085C28.7867 20.8807 28.6714 20.2521 28.4081 19.6806C28.1448 19.1091 27.7418 18.6131 27.2364 18.2382C26.731 17.8633 26.1394 17.6216 25.5161 17.5354C24.8928 17.4491 24.2578 17.5212 23.6696 17.7448C23.0814 17.9684 22.559 18.3364 22.1504 18.815"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImageFallbackIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g opacity="0.6" clipPath="url(#clip0_1268_3459)">
        <path
          d="M14.224 1.77832H1.77951C1.54377 1.77832 1.31767 1.87197 1.15097 2.03867C0.984275 2.20537 0.890625 2.43146 0.890625 2.66721V13.3339C0.890625 13.5696 0.984275 13.7957 1.15097 13.9624C1.31767 14.1291 1.54377 14.2228 1.77951 14.2228H14.224C14.4597 14.2228 14.6858 14.1291 14.8525 13.9624C15.0192 13.7957 15.1128 13.5696 15.1128 13.3339V2.66721C15.1128 2.43146 15.0192 2.20537 14.8525 2.03867C14.6858 1.87197 14.4597 1.77832 14.224 1.77832ZM1.77951 13.3339V2.66721H14.224V13.3339H1.77951Z"
          fill="#404040"
        />
        <path
          d="M3.96615 6.22233C4.22985 6.22233 4.48764 6.14413 4.70691 5.99762C4.92617 5.85112 5.09707 5.64288 5.19799 5.39924C5.2989 5.15561 5.32531 4.88752 5.27386 4.62888C5.22241 4.37024 5.09542 4.13266 4.90895 3.94619C4.72248 3.75972 4.48491 3.63273 4.22627 3.58128C3.96762 3.52984 3.69954 3.55624 3.4559 3.65716C3.21227 3.75808 3.00403 3.92897 2.85752 4.14824C2.71101 4.3675 2.63281 4.62529 2.63281 4.889C2.63281 5.24262 2.77329 5.58176 3.02334 5.83181C3.27339 6.08186 3.61252 6.22233 3.96615 6.22233ZM3.96615 4.17789C4.10698 4.17701 4.2449 4.21796 4.36242 4.29556C4.47995 4.37317 4.57178 4.48392 4.62629 4.61377C4.68079 4.74363 4.69551 4.88675 4.66858 5.02498C4.64164 5.16322 4.57427 5.29034 4.475 5.39024C4.37572 5.49013 4.24903 5.5583 4.11096 5.5861C3.9729 5.6139 3.82969 5.60008 3.6995 5.54639C3.5693 5.4927 3.45797 5.40156 3.37964 5.28453C3.3013 5.16749 3.25948 5.02983 3.25948 4.889C3.26064 4.70194 3.33547 4.52287 3.46775 4.3906C3.60002 4.25832 3.77909 4.1835 3.96615 4.18233V4.17789Z"
          fill="#404040"
        />
        <path
          d="M10.1261 6.83139L7.72615 9.23139L5.94837 7.45361C5.8651 7.37083 5.75245 7.32437 5.63503 7.32437C5.51762 7.32437 5.40497 7.37083 5.3217 7.45361L2.63281 10.1781V11.4358L5.65059 8.41806L7.11281 9.85806L5.44615 11.5247H6.66837L10.4239 7.76917L13.335 10.6669V9.41361L10.7528 6.83139C10.6695 6.74861 10.5569 6.70215 10.4395 6.70215C10.3221 6.70215 10.2094 6.74861 10.1261 6.83139Z"
          fill="#404040"
        />
      </g>
      <defs>
        <clipPath id="clip0_1268_3459">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorBoundaryFallBack = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 7.5V17.5C35 18.163 35.2634 18.7989 35.7322 19.2678C36.2011 19.7366 36.837 20 37.5 20H47.5"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 35H25.025M35 35H35.025M42.5 52.5H17.5C16.1739 52.5 14.9021 51.9732 13.9645 51.0355C13.0268 50.0979 12.5 48.8261 12.5 47.5V12.5C12.5 11.1739 13.0268 9.90215 13.9645 8.96447C14.9021 8.02678 16.1739 7.5 17.5 7.5H35L47.5 20V47.5C47.5 48.8261 46.9732 50.0979 46.0355 51.0355C45.0979 51.9732 43.8261 52.5 42.5 52.5Z"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 45.0009C26.4672 43.9793 28.2121 43.4316 30 43.4316C31.7879 43.4316 33.5328 43.9793 35 45.0009"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WaitingFallBackIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.3548 32.5525C52.8663 28.0721 52.0198 23.5414 49.925 19.548C47.8302 15.5546 44.5837 12.2828 40.6067 10.157C36.6297 8.03113 32.1057 7.14939 27.6215 7.62608C23.1373 8.10278 18.8998 9.91593 15.4586 12.8303C12.0174 15.7447 9.53139 19.6259 8.32294 23.9705C7.1145 28.315 7.23941 32.9225 8.68147 37.1952C10.1235 41.4679 12.8162 45.2087 16.4102 47.9323C20.0043 50.656 24.3338 52.2369 28.8373 52.47"
        stroke="#20C74F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 17.5V30L37.5 37.5"
        stroke="#20C74F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 47.5L42.5 52.5L52.5 42.5"
        stroke="#20C74F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3H15M1 8H10.3333M1 13H4.73333"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ResetIcon = (props) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3811 11.6828C10.6662 12.3394 9.77549 12.7736 8.8178 12.9325C7.86011 13.0915 6.87686 12.9682 5.98808 12.5778C5.09931 12.1873 4.34347 11.5467 3.81285 10.734C3.28223 9.92124 2.99978 8.97166 3 8.00115H3.83319C3.83313 8.84002 4.08647 9.65935 4.56003 10.3519C5.03358 11.0444 5.70528 11.5778 6.48718 11.8822C7.26907 12.1867 8.1247 12.248 8.94204 12.0582C9.75937 11.8683 10.5003 11.4361 11.0678 10.8182H9.85719C9.7467 10.8182 9.64074 10.7743 9.56261 10.6962C9.48448 10.6181 9.44059 10.5122 9.44059 10.4017C9.44059 10.2913 9.48448 10.1853 9.56261 10.1072C9.64074 10.0291 9.7467 9.98525 9.85719 9.98525H11.7977C11.9082 9.98525 12.0142 10.0291 12.0923 10.1072C12.1704 10.1853 12.2143 10.2913 12.2143 10.4017V12.34C12.2143 12.4505 12.1704 12.5564 12.0923 12.6345C12.0142 12.7126 11.9082 12.7565 11.7977 12.7565C11.6872 12.7565 11.5812 12.7126 11.5031 12.6345C11.425 12.5564 11.3811 12.4505 11.3811 12.34V11.682V11.6828ZM4.93051 5.18493H6.14114C6.25163 5.18493 6.35759 5.22881 6.43572 5.30691C6.51385 5.38502 6.55774 5.49095 6.55774 5.60141C6.55774 5.71186 6.51385 5.8178 6.43572 5.8959C6.35759 5.974 6.25163 6.01788 6.14114 6.01788H4.1998C4.08931 6.01788 3.98335 5.974 3.90522 5.8959C3.82709 5.8178 3.7832 5.71186 3.7832 5.60141V3.66145C3.7832 3.551 3.82709 3.44507 3.90522 3.36696C3.98335 3.28886 4.08931 3.24498 4.1998 3.24498C4.31029 3.24498 4.41625 3.28886 4.49438 3.36696C4.57251 3.44507 4.6164 3.551 4.6164 3.66145V4.31949C5.33124 3.66212 6.22215 3.22717 7.18025 3.06779C8.13836 2.90841 9.12216 3.0315 10.0114 3.42202C10.9007 3.81254 11.6569 4.45357 12.1876 5.26678C12.7184 6.07999 13.0007 7.03015 13 8.00115H12.1668C12.1669 7.16217 11.9135 6.34273 11.4398 5.65015C10.9662 4.95758 10.2943 4.42417 9.51228 4.11978C8.73025 3.81539 7.87448 3.75422 7.05708 3.94428C6.23968 4.13434 5.49875 4.56677 4.93134 5.18493H4.93051Z"
        stroke={props.color || "#404040"}
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width={props.width || "18"}
      height={props.height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54439 1C6.25003 1 4.98474 1.38389 3.90852 2.10313C2.8323 2.82237 1.99349 3.84465 1.49816 5.0407C1.00284 6.23675 0.873235 7.55285 1.12575 8.82257C1.37827 10.0923 2.00156 11.2586 2.91681 12.174C3.83206 13.0894 4.99816 13.7128 6.26764 13.9654C7.53713 14.218 8.85299 14.0884 10.0488 13.5929C11.2447 13.0975 12.2667 12.2585 12.9859 11.1821C13.705 10.1057 14.0888 8.84019 14.0888 7.54559C14.0887 5.80963 13.3991 4.14479 12.1719 2.91728C10.9446 1.68977 9.28004 1.00011 7.54439 1Z"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4297 12.4288L17.0002 17.0002"
        stroke={props.color || "#404040"}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const WarningIcon = (props) => {
  return (
    <svg
      width={props.width || "60"}
      height={props.width || "60"}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 22.5V32.5"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9072 8.97797L5.64222 42.813C5.22446 43.5364 5.00339 44.3567 5.001 45.1921C4.9986 46.0275 5.21497 46.849 5.62858 47.5748C6.0422 48.3006 6.63863 48.9056 7.35857 49.3294C8.07851 49.7532 8.89686 49.9811 9.73222 49.9905H50.2672C51.1022 49.9808 51.9201 49.7529 52.6397 49.3292C53.3593 48.9055 53.9555 48.3009 54.3691 47.5754C54.7826 46.85 54.9991 46.0289 54.997 45.1939C54.9949 44.3588 54.7744 43.5389 54.3572 42.8155L34.0922 8.97547C33.6659 8.27173 33.0652 7.68983 32.3483 7.28597C31.6315 6.8821 30.8225 6.66992 29.9997 6.66992C29.1769 6.66992 28.368 6.8821 27.6511 7.28597C26.9342 7.68983 26.3336 8.27173 25.9072 8.97547V8.97797Z"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 40H30.025"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GetNearestLocationIcon = (props) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.1425 41.6418L33.535 52.2493C32.5975 53.1859 31.3265 53.712 30.0013 53.712C28.6761 53.712 27.405 53.1859 26.4675 52.2493L15.8575 41.6418C13.0606 38.8447 11.1558 35.281 10.3842 31.4014C9.61261 27.5218 10.0087 23.5006 11.5225 19.8461C13.0363 16.1916 15.5998 13.0681 18.8887 10.8705C22.1777 8.67295 26.0444 7.5 30 7.5C33.9556 7.5 37.8223 8.67295 41.1113 10.8705C44.4003 13.0681 46.9637 16.1916 48.4775 19.8461C49.9913 23.5006 50.3874 27.5218 49.6158 31.4014C48.8442 35.281 46.9395 38.8447 44.1425 41.6418Z"
        stroke={props.color || "#20C74F"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OfflineIcon = (props) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 45H30.0254"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9297 37.9298C24.805 36.0551 27.348 35.002 29.9997 35.002C32.6513 35.002 35.1944 36.0551 37.0697 37.9298"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8574 30.8578C18.5085 28.1992 21.8573 26.3445 25.5174 25.5078M35.9249 25.8953C39.0315 26.8654 41.853 28.5821 44.1424 30.8953"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.78711 23.7879C11.3457 21.2239 14.3475 19.1446 17.6471 17.6504M25.3996 15.3504C30.0623 14.6274 34.8299 15.0144 39.3149 16.48C43.8 17.9457 47.8761 20.4485 51.2121 23.7854"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5L52.5 52.5"
        stroke="#D0405A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MultipleLocationFoundIcon = (props) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.2504 52.5C36.1407 52.7394 35.9646 52.9422 35.7431 53.0844C35.5215 53.2266 35.2637 53.3022 35.0004 53.3022C34.7371 53.3022 34.4794 53.2266 34.2578 53.0844C34.0362 52.9422 33.8601 52.7394 33.7504 52.5L25.0004 35L7.50042 26.25C7.26107 26.1403 7.05824 25.9642 6.91604 25.7426C6.77383 25.521 6.69824 25.2633 6.69824 25C6.69824 24.7367 6.77383 24.479 6.91604 24.2574C7.05824 24.0358 7.26107 23.8597 7.50042 23.75L52.5004 7.5L45.0829 28.0375"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 55V55.025"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 47.4994C48.6207 47.4958 49.7079 47.1164 50.5874 46.4218C51.467 45.7272 52.0881 44.7576 52.3514 43.6682C52.6147 42.5789 52.5049 41.4326 52.0396 40.413C51.5743 39.3934 50.7804 38.5594 49.785 38.0444C48.7904 37.5349 47.6528 37.377 46.557 37.5962C45.4613 37.8154 44.472 38.399 43.75 39.2519"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ApprovalPendingIcon = (props) => {
  return (
    <svg
      width={props.width || "60"}
      height={props.width || "60"}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.4652 31.2555C52.7339 26.4318 51.4429 21.6497 48.7831 17.6166C46.1233 13.5835 42.2359 10.5136 37.6961 8.86107C33.1563 7.20855 28.2052 7.06117 23.5751 8.44072C18.9451 9.82028 14.882 12.6535 11.987 16.5212C9.092 20.389 7.51882 25.0859 7.50017 29.9171C7.48152 34.7482 9.0184 39.4571 11.8835 43.3471C14.7485 47.2371 18.7896 50.1016 23.4088 51.5168C28.0281 52.9321 32.9802 52.823 37.5327 51.2055"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 17.5V30L37.5 37.5"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 40V47.5"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 55V55.025"
        stroke="#D17541"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThemeIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2956_22677)">
        <path
          d="M10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C14.1417 2.5 17.5 5.485 17.5 9.16667C17.5 10.05 17.105 10.8983 16.4017 11.5233C15.6983 12.1483 14.7442 12.5 13.75 12.5H11.6667C11.2949 12.494 10.9318 12.6125 10.6351 12.8367C10.3384 13.0608 10.1252 13.3777 10.0294 13.737C9.93362 14.0963 9.9607 14.4773 10.1064 14.8194C10.252 15.1615 10.5079 15.4451 10.8333 15.625C10.9997 15.7785 11.1138 15.9803 11.1596 16.2021C11.2054 16.4238 11.1806 16.6543 11.0886 16.8612C10.9967 17.068 10.8422 17.2409 10.647 17.3555C10.4517 17.4701 10.2255 17.5206 10 17.5Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 8.75033C6.25 8.97134 6.3378 9.1833 6.49408 9.33958C6.65036 9.49586 6.86232 9.58366 7.08333 9.58366C7.30435 9.58366 7.51631 9.49586 7.67259 9.33958C7.82887 9.1833 7.91667 8.97134 7.91667 8.75033C7.91667 8.52931 7.82887 8.31735 7.67259 8.16107C7.51631 8.00479 7.30435 7.91699 7.08333 7.91699C6.86232 7.91699 6.65036 8.00479 6.49408 8.16107C6.3378 8.31735 6.25 8.52931 6.25 8.75033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5835 6.25033C9.5835 6.47134 9.67129 6.6833 9.82757 6.83958C9.98385 6.99586 10.1958 7.08366 10.4168 7.08366C10.6378 7.08366 10.8498 6.99586 11.0061 6.83958C11.1624 6.6833 11.2502 6.47134 11.2502 6.25033C11.2502 6.02931 11.1624 5.81735 11.0061 5.66107C10.8498 5.50479 10.6378 5.41699 10.4168 5.41699C10.1958 5.41699 9.98385 5.50479 9.82757 5.66107C9.67129 5.81735 9.5835 6.02931 9.5835 6.25033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9165 8.75033C12.9165 8.97134 13.0043 9.1833 13.1606 9.33958C13.3169 9.49586 13.5288 9.58366 13.7498 9.58366C13.9709 9.58366 14.1828 9.49586 14.3391 9.33958C14.4954 9.1833 14.5832 8.97134 14.5832 8.75033C14.5832 8.52931 14.4954 8.31735 14.3391 8.16107C14.1828 8.00479 13.9709 7.91699 13.7498 7.91699C13.5288 7.91699 13.3169 8.00479 13.1606 8.16107C13.0043 8.31735 12.9165 8.52931 12.9165 8.75033Z"
          stroke={props.color || "white"}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2956_22677">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AppInfoIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33424 17.3134C7.60892 17.1488 6.91231 16.8767 6.26758 16.5059"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.666 2.68555C13.3228 3.06394 14.8021 3.99362 15.8616 5.32239C16.9211 6.65115 17.498 8.30026 17.498 9.99971C17.498 11.6992 16.9211 13.3483 15.8616 14.677C14.8021 16.0058 13.3228 16.9355 11.666 17.3139"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.81547 14.244C3.36089 13.5835 3.01564 12.8542 2.79297 12.084"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.60352 8.75091C2.73685 7.95924 2.99352 7.20924 3.35352 6.52174L3.49435 6.26758"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75586 3.81555C6.53557 3.2788 7.41029 2.89531 8.33336 2.68555"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.5V12.5"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10L10 12.5L7.5 10"
        stroke={props.color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ComplaintIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6665 20.7993C14.6665 20.3575 15.0247 19.9993 15.4665 19.9993H16.5332C16.975 19.9993 17.3332 20.3575 17.3332 20.7993V21.866C17.3332 22.3078 16.975 22.666 16.5332 22.666H15.4665C15.0247 22.666 14.6665 22.3078 14.6665 21.866V20.7993ZM14.6665 10.1327C14.6665 9.69085 15.0247 9.33268 15.4665 9.33268H16.5332C16.975 9.33268 17.3332 9.69085 17.3332 10.1327V16.5327C17.3332 16.9745 16.975 17.3327 16.5332 17.3327H15.4665C15.0247 17.3327 14.6665 16.9745 14.6665 16.5327V10.1327ZM15.9998 2.66602C8.6265 2.66602 2.6665 8.66602 2.6665 15.9993C2.6665 19.5356 4.07126 22.927 6.57175 25.4274C7.80986 26.6656 9.27972 27.6477 10.8974 28.3177C12.5151 28.9878 14.2489 29.3327 15.9998 29.3327C19.5361 29.3327 22.9274 27.9279 25.4279 25.4274C27.9284 22.927 29.3332 19.5356 29.3332 15.9993C29.3332 14.2484 28.9883 12.5146 28.3182 10.8969C27.6482 9.27923 26.666 7.80937 25.4279 6.57126C24.1898 5.33314 22.72 4.35102 21.1023 3.68096C19.4846 3.01089 17.7508 2.66602 15.9998 2.66602ZM15.9998 26.666C13.1709 26.666 10.4578 25.5422 8.45737 23.5418C6.45698 21.5414 5.33317 18.8283 5.33317 15.9993C5.33317 13.1704 6.45698 10.4573 8.45737 8.45688C10.4578 6.45649 13.1709 5.33268 15.9998 5.33268C18.8288 5.33268 21.5419 6.45649 23.5423 8.45688C25.5427 10.4573 26.6665 13.1704 26.6665 15.9993C26.6665 18.8283 25.5427 21.5414 23.5423 23.5418C21.5419 25.5422 18.8288 26.666 15.9998 26.666Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const ProcedureIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2802 12.6267C19.3098 12.0665 20.8002 10.2069 20.8002 7.99922C20.8002 5.34825 18.6512 3.19922 16.0002 3.19922C13.3492 3.19922 11.2002 5.34825 11.2002 7.99922C11.2002 10.2069 12.6906 12.0665 14.7202 12.6267V14.7192H9.6002C8.00961 14.7192 6.7202 16.0086 6.7202 17.5992V19.3718C4.69064 19.9319 3.2002 21.7915 3.2002 23.9992C3.2002 26.6502 5.34923 28.7992 8.0002 28.7992C10.6512 28.7992 12.8002 26.6502 12.8002 23.9992C12.8002 21.7915 11.3098 19.9319 9.2802 19.3718V17.5992C9.2802 17.4225 9.42346 17.2792 9.6002 17.2792H22.4002C22.5769 17.2792 22.7202 17.4225 22.7202 17.5992V19.3718C20.6906 19.9319 19.2002 21.7915 19.2002 23.9992C19.2002 26.6502 21.3492 28.7992 24.0002 28.7992C26.6512 28.7992 28.8002 26.6502 28.8002 23.9992C28.8002 21.7915 27.3098 19.9319 25.2802 19.3718V17.5992C25.2802 16.0086 23.9908 14.7192 22.4002 14.7192H17.2802V12.6267ZM18.2402 7.99922C18.2402 9.23634 17.2373 10.2392 16.0002 10.2392C14.7631 10.2392 13.7602 9.23634 13.7602 7.99922C13.7602 6.7621 14.7631 5.75922 16.0002 5.75922C17.2373 5.75922 18.2402 6.7621 18.2402 7.99922ZM26.2402 23.9992C26.2402 25.2363 25.2373 26.2392 24.0002 26.2392C22.7631 26.2392 21.7602 25.2363 21.7602 23.9992C21.7602 22.7621 22.7631 21.7592 24.0002 21.7592C25.2373 21.7592 26.2402 22.7621 26.2402 23.9992ZM8.0002 26.2392C9.23731 26.2392 10.2402 25.2363 10.2402 23.9992C10.2402 22.7621 9.23731 21.7592 8.0002 21.7592C6.76308 21.7592 5.7602 22.7621 5.7602 23.9992C5.7602 25.2363 6.76308 26.2392 8.0002 26.2392Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const CallIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.43617 4.26847C8.03776 2.5899 10.6751 2.88816 12.0161 4.77759L13.6769 7.11372C14.7692 8.65079 14.6718 10.7983 13.3755 12.1564L13.0623 12.4865C13.027 12.6252 13.0233 12.7706 13.0518 12.911C13.1347 13.477 13.5835 14.6756 15.4627 16.6455C17.342 18.6154 18.487 19.0871 19.0318 19.1758C19.1689 19.2066 19.3111 19.2023 19.4463 19.1634L19.9833 18.6001C21.1361 17.3932 22.9048 17.1671 24.3314 17.9842L26.845 19.4269C28.9993 20.6588 29.5428 23.7441 27.7794 25.5933L25.9093 27.5521C25.3197 28.1694 24.5275 28.6841 23.5615 28.7798C21.1795 29.0142 15.6299 28.7146 9.79596 22.601C4.35159 16.8938 3.30667 11.9164 3.17376 9.46372C3.10796 8.22352 3.66332 7.17476 4.37133 6.43396L6.43617 4.26847ZM10.4369 6.02473C9.76964 5.08556 8.52732 5.01065 7.8272 5.7445L5.76105 7.90861C5.32676 8.36363 5.11883 8.86581 5.14515 9.3458C5.25043 11.2949 6.09269 15.7854 11.1883 21.1263C16.534 26.728 21.4704 26.8959 23.3786 26.7072C23.7681 26.6698 24.155 26.4561 24.517 26.0774L26.3857 24.1172C27.1464 23.3209 26.9792 21.8699 25.9027 21.2539L23.3891 19.8126C22.6943 19.4158 21.881 19.5462 21.3756 20.0762L20.7768 20.7046L20.0793 19.9666C20.7768 20.7046 20.7755 20.706 20.7742 20.706L20.7729 20.7088L20.7689 20.7129L20.7597 20.7212L20.74 20.7407C20.684 20.7945 20.6242 20.8437 20.561 20.8877C20.4557 20.9612 20.3162 21.0431 20.1412 21.1111C19.7859 21.2512 19.3147 21.3261 18.733 21.2318C17.5921 21.0472 16.08 20.2274 14.0704 18.1215C12.0621 16.0157 11.2778 14.4315 11.1015 13.2301C11.0106 12.6169 11.083 12.1203 11.2173 11.7457C11.2917 11.5352 11.3974 11.3386 11.5305 11.1631L11.5726 11.1145L11.591 11.0937L11.5989 11.0854L11.6029 11.0812L11.6055 11.0785L11.9845 10.6817C12.5478 10.0894 12.6267 9.10858 12.0964 8.36085L10.4369 6.02473Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const TrackIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0108 29.0723L8.77297 18.8514C7.58827 17.4526 6.82534 15.7461 6.57304 13.9305C6.32074 12.1149 6.58945 10.265 7.34787 8.5962C8.1063 6.92741 9.32322 5.50844 10.8569 4.50455C12.3906 3.50065 14.178 2.95314 16.0108 2.92578C18.5515 2.95089 20.9786 3.98186 22.7607 5.79288C24.5428 7.60391 25.5345 10.0474 25.5186 12.5881C25.5196 14.8046 24.765 16.9551 23.3794 18.685L16.0108 29.0723ZM16.0108 5.30274C14.0996 5.32469 12.2751 6.10422 10.9382 7.47017C9.60117 8.83613 8.86091 10.6768 8.87993 12.5881C8.88789 14.3326 9.51551 16.0175 10.6508 17.342L16.0108 24.9364L21.5135 17.1875C22.5594 15.8819 23.1332 14.261 23.1417 12.5881C23.1607 10.6768 22.4204 8.83613 21.0835 7.47017C19.7465 6.10422 17.9221 5.32469 16.0108 5.30274Z"
        fill="#CFCFCF"
      />
      <path
        d="M16.0105 13.6221C17.3232 13.6221 18.3874 12.5579 18.3874 11.2451C18.3874 9.93238 17.3232 8.86818 16.0105 8.86818C14.6977 8.86818 13.6335 9.93238 13.6335 11.2451C13.6335 12.5579 14.6977 13.6221 16.0105 13.6221Z"
        fill="#CFCFCF"
      />
    </svg>
  );
};

export const FaceRecIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7602 2.24023L25.6002 2.24023V4.16023H27.8402V6.40023H29.7602V2.24023Z"
        fill="#D9D9D9"
      />
      <path
        d="M2.24023 2.24023H6.40023V4.16023H4.16023V6.40023H2.24023V2.24023Z"
        fill="#D9D9D9"
      />
      <path
        d="M29.7602 29.7602H25.6002V27.8402H27.8402V25.6002H29.7602V29.7602Z"
        fill="#D9D9D9"
      />
      <path
        d="M2.24023 29.7602L2.24023 25.6002H4.16023V27.8402H6.40023V29.7602H2.24023Z"
        fill="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21436 23.4682C5.77333 23.8661 5.76663 24.5485 6.20179 24.9527C6.62283 25.3439 7.27122 25.2991 7.7042 24.9212C10.0022 22.9157 12.9006 21.792 16.0007 21.792C19.1007 21.792 21.999 22.9156 24.2969 24.921C24.7298 25.2987 25.3779 25.3434 25.7988 24.9524C26.2338 24.5482 26.227 23.866 25.7861 23.4683C24.2844 22.1139 22.55 21.0914 20.6701 20.4525C22.3877 19.3892 23.7223 17.7689 24.4687 15.8405C25.2151 13.9121 25.3322 11.7822 24.8019 9.77785C24.2717 7.77354 23.1234 6.00566 21.5334 4.7457C19.9435 3.48574 17.9997 2.80336 16.0007 2.80336C14.0017 2.80336 12.058 3.48574 10.4681 4.7457C8.8781 6.00566 7.72981 7.77354 7.19955 9.77785C6.66928 11.7822 6.78635 13.9121 7.53278 15.8405C8.27922 17.7689 9.61374 19.3892 11.3314 20.4525C9.451 21.0908 7.71633 22.1133 6.21436 23.4682ZM8.90102 12.2995C8.90102 10.8393 9.31741 9.41181 10.0975 8.19767C10.8777 6.98353 11.9865 6.03722 13.2838 5.47841C14.5811 4.9196 16.0086 4.77339 17.3858 5.05827C18.763 5.34314 20.0281 6.04632 21.021 7.07886C22.0139 8.1114 22.6901 9.42695 22.964 10.8591C23.238 12.2913 23.0974 13.7758 22.56 15.1249C22.0227 16.474 21.1127 17.6271 19.9451 18.4383C18.7776 19.2496 17.4049 19.6826 16.0007 19.6826C14.1184 19.6805 12.3137 18.902 10.9827 17.5178C9.65168 16.1337 8.90303 14.257 8.90102 12.2995Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export const ShareIcon = (props) => {
  return (
    <svg
      width={props.height || "16"}
      height={props.width || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69584 1.71674C5.8384 1.71674 5.97511 1.77337 6.07591 1.87417C6.17671 1.97497 6.23334 2.11169 6.23334 2.25424C6.23334 2.3968 6.17671 2.53351 6.07591 2.63431C5.97511 2.73511 5.8384 2.79174 5.69584 2.79174H3.18751C2.75984 2.79174 2.3497 2.96163 2.04729 3.26403C1.74489 3.56644 1.575 3.97658 1.575 4.40425V11.9293L1.5836 12.0941C1.6244 12.4911 1.81097 12.8589 2.10724 13.1263C2.4035 13.3937 2.78841 13.5417 3.18751 13.5418H10.7125C11.1402 13.5418 11.5503 13.3719 11.8527 13.0695C12.1551 12.7671 12.325 12.3569 12.325 11.9293V10.4959C12.325 10.3534 12.3817 10.2167 12.4825 10.1159C12.5833 10.0151 12.72 9.95842 12.8625 9.95842C13.0051 9.95842 13.1418 10.0151 13.2426 10.1159C13.3434 10.2167 13.4 10.3534 13.4 10.4959V11.9293C13.4 12.642 13.1169 13.3256 12.6129 13.8296C12.1089 14.3336 11.4253 14.6168 10.7125 14.6168H3.18751C2.49868 14.6168 1.83616 14.3523 1.33671 13.8779C0.837269 13.4035 0.539035 12.7555 0.503583 12.0676L0.5 11.9293V4.40425C0.5 3.69148 0.783147 3.0079 1.28715 2.50389C1.79116 1.99989 2.47473 1.71674 3.18751 1.71674H5.69584ZM9.05487 1.04881C9.14828 1.00603 9.25201 0.990918 9.35375 1.00527C9.45549 1.01962 9.55098 1.06284 9.62892 1.12979L14.6456 5.4298C14.7024 5.47856 14.7484 5.53864 14.7806 5.6062C14.8128 5.67376 14.8306 5.7473 14.8327 5.82212C14.8349 5.89694 14.8214 5.97139 14.7931 6.04069C14.7649 6.11 14.7224 6.17263 14.6685 6.22458L9.65185 11.0621C9.5759 11.1352 9.48014 11.1843 9.37649 11.2034C9.27283 11.2225 9.16586 11.2106 9.06886 11.1694C8.97187 11.1282 8.88914 11.0593 8.83097 10.9714C8.7728 10.8835 8.74175 10.7805 8.74168 10.6751V8.54229C8.01498 8.58815 7.32985 8.73794 6.63468 9.0934C5.82054 9.50979 4.95481 10.2265 3.99089 11.4606L3.79667 11.7143C3.72899 11.8045 3.63462 11.8712 3.52694 11.9048C3.41926 11.9384 3.30372 11.9374 3.1967 11.9017C3.08968 11.866 2.99659 11.7976 2.93063 11.706C2.86467 11.6145 2.82917 11.5046 2.82917 11.3918C2.82917 9.34424 3.32152 7.38558 4.38291 5.92501C5.36904 4.56836 6.82675 3.66966 8.74168 3.52848V1.53757L8.74742 1.45946C8.76038 1.37081 8.79529 1.28681 8.84899 1.21509C8.90268 1.14337 8.97346 1.08621 9.05487 1.04881ZM9.81668 4.04591C9.81668 4.18847 9.76005 4.32518 9.65925 4.42598C9.55845 4.52678 9.42174 4.58341 9.27918 4.58341C7.44666 4.58341 6.12943 5.35025 5.25294 6.5564C4.62371 7.42213 4.21091 8.53225 4.02242 9.77639C4.73909 9.02532 5.43928 8.49714 6.14519 8.13522C7.20801 7.5927 8.24001 7.45009 9.27918 7.45009C9.42174 7.45009 9.55845 7.50671 9.65925 7.60752C9.76005 7.70832 9.81668 7.84503 9.81668 7.98759V9.40946L13.4968 5.86052L9.81668 2.70574V4.04591Z"
        fill={props.color || "#CFCFCF"}
      />
    </svg>
  );
};

export const CopyIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6065_10349)">
        <path
          d="M4.66602 6.44402C4.66602 5.97246 4.85334 5.52022 5.18678 5.18678C5.52022 4.85334 5.97246 4.66602 6.44402 4.66602H12.2213C12.4548 4.66602 12.686 4.71201 12.9018 4.80136C13.1175 4.89071 13.3135 5.02168 13.4786 5.18678C13.6437 5.35188 13.7747 5.54789 13.864 5.7636C13.9534 5.97932 13.9993 6.21053 13.9993 6.44402V12.2213C13.9993 12.4548 13.9534 12.686 13.864 12.9018C13.7747 13.1175 13.6437 13.3135 13.4786 13.4786C13.3135 13.6437 13.1175 13.7747 12.9018 13.864C12.686 13.9534 12.4548 13.9993 12.2213 13.9993H6.44402C6.21053 13.9993 5.97932 13.9534 5.7636 13.864C5.54789 13.7747 5.35188 13.6437 5.18678 13.4786C5.02168 13.3135 4.89071 13.1175 4.80136 12.9018C4.71201 12.686 4.66602 12.4548 4.66602 12.2213V6.44402Z"
          stroke={"var(--tertiaryColor6)" || props.color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667"
          stroke={"var(--tertiaryColor6)" || props.color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6065_10349">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GoToLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6676 3.42131L7.10547 8.9834"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13 3V6.33333"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9.66602 3L12.9993 3"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M6.33333 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V9.66667"
        stroke="var(--tertiaryColor6)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};
